export default class PlayerVehicleModel {

    public vehicleName: string | undefined;
    public imageUrl: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.vehicleName = data['vehicleName'] || undefined;
        this.imageUrl = data['imageUrl'] || undefined;
    }
}